import { createSlice } from '@reduxjs/toolkit';
import { getOperationToday } from 'shared/lib/dateFormatter';
import { todoFilterHandler } from 'shared/lib/todoFilterHandler';

const taskboardSlice = createSlice({
    name: 'taskboard',
    initialState: [],
    reducers: {
        setTaskboard: (state, action) => {
            const newState = action.payload.map((memberTodo) => {
                // Every member's board must show the same cards no matter where the
                // viewer sits — the day a task belongs to is the operations day (LA).
                const today = getOperationToday();
                const newMemberTodo = {
                    ...memberTodo,
                    todoRows: todoFilterHandler(memberTodo.shipment_todo, today, 'taskboard'),
                };
                delete newMemberTodo['shipment_todo'];

                return newMemberTodo;
            });

            return newState;
        },
    },
});

export const { setTaskboard } = taskboardSlice.actions;
export default taskboardSlice.reducer;
